<mat-sidenav-container class="example-sidenav-container">


  <!-- shared.layout.header -->
  <rsp-header *ngIf="!isMock"></rsp-header>

  <!-- content -->
  <router-outlet></router-outlet>

  <!-- footer -->
  <div class="footer mat-toolbar">
    <div class="wrapper">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10%">
        <div class="social" fxFlex="45%" style="text-align: left">
          <a *ngFor="let social of sociallinks" href="{{social.link}}" target="_blank"><i
            class="{{social.iconCode}}"></i></a>
        </div>
        <div class="appendix" fxFlex="45%">
          © KISTERS AG {{ today | date:'y' }} | <a routerLink="/kontakt">Kontakt</a> |
          <a routerLink="/impressum">Impressum</a> | <a routerLink="/datenschutz">Datenschutz</a><br/>
        </div>

      </div>
    </div>
  </div>


</mat-sidenav-container>
